/**
 * Safari-specific detection — needed to gate workarounds for Safari-only rendering bugs
 * (e.g. phantom values in native date/time inputs).
 *
 * Checks for Safari by confirming the UA contains "Safari" but not "Chrome" or "Chromium",
 * since Chromium-based browsers also include "Safari" in their UA string.
 */
export const isSafari = (() => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent;

  return (
    /Safari/i.test(ua) &&
    /Version\/[\d.]+/i.test(ua) &&
    !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua)
  );
})();
